import React, {useState} from "react"

import {Account} from "../../../resources/account"
import {useAccessToken} from "../../../services/auth"

import {useAsyncResult} from "../../../hooks/useAsyncResult"
import {Address} from "../../../resources/common"
import {getActiveClosureCheckPayment} from "../../../resources/checkPayments"

import {ChangeMailingAddressModal} from "./ChangeMailingAddress"
import {ReIssueClosureCheckModal} from "./ReIssueClosureCheck"
import {NewClosureCheckModal} from "./NewClosureCheck"
import {ClosureCheckErrorModal} from "./ClosureCheckError"

interface CreateClosureCheckModalProps {
	account: Account
	customerId: string
	customerAddress: Address
	closeModal: () => void
	onSuccess: () => void
}

export function CreateClosureCheckModal({
	account,
	customerId,
	customerAddress,
	closeModal,
	onSuccess,
}: CreateClosureCheckModalProps) {
	const accessToken = useAccessToken()
	const accountId = account.id
	const activeClosureChecks = useAsyncResult(() => getActiveClosureCheckPayment(accessToken, customerId, accountId), [])

	const [isChangeAddressModalOpen, setIsChangeAddressModalOpen] = useState(false)
	const [updatedAddress, setUpdatedAddress] = useState(customerAddress)
	const openChangeAddressModal = () => setIsChangeAddressModalOpen(true)
	const closeChangeAddressModal = () => setIsChangeAddressModalOpen(false)
	const handleAddressSave = (newAddress: Address) => {
		setUpdatedAddress(newAddress)
		closeChangeAddressModal()
	}

	return activeClosureChecks.match(
		() => <></>,
		(maybeCheck) => {
			if (isChangeAddressModalOpen) {
				return (
					<ChangeMailingAddressModal
						address={updatedAddress}
						closeModal={closeChangeAddressModal}
						onSuccess={handleAddressSave}
					/>
				)
			} else {
				return (
					<>
						{activeClosureChecks.match(
							() => (
								<></>
							),
							() => {
								if (maybeCheck.data.length > 0) {
									const existingCheck = maybeCheck.data[0]
									return (
										<>
											<ReIssueClosureCheckModal
												account={account}
												customerId={customerId}
												updatedAddress={updatedAddress}
												openChangeAddressModal={openChangeAddressModal}
												existingCheck={existingCheck}
												closeModal={closeModal}
												onSuccess={onSuccess}
											/>
										</>
									)
								} else {
									return (
										<NewClosureCheckModal
											account={account}
											customerId={customerId}
											updatedAddress={updatedAddress}
											openChangeAddressModal={openChangeAddressModal}
											closeModal={closeModal}
											onSuccess={onSuccess}
										/>
									)
								}
							},
							() => null
						)}
					</>
				)
			}
		},
		(e) => <ClosureCheckErrorModal error={e.errors[0].title} closeModal={closeModal} onSuccess={onSuccess} />
	)
}
